import styled from "styled-components";

export const LinkWrapper = styled.span`
  &[disabled] {
    a {
      pointer-events: none;
    }
  }
`;
